import { render, staticRenderFns } from "./CommissionEdit.vue?vue&type=template&id=2200652b&"
import script from "./CommissionEdit.vue?vue&type=script&lang=js&"
export * from "./CommissionEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommissionEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports